import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { Link } from "@mui/material";

export const purchaseSeatsLanguages = {
  progressBarAditionalText: " to continue!",
  progressBarSuccessText:
    "You're good to go! Add more games or select Continue to view seating options. ",
  similarSeatModalBody: (seatTitle: string) => {
    return <>Do you want to apply seat selection for all games in your pack?</>;
  },
  similarSeatModalPrimaryButton: "Apply selection for all games",
  similarSeatModalSecondaryButton: "I want to choose seats",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description: (
      <>
        Click Continue and connect to your St. Louis Blues{" "}
        <Link
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
          href="https://am.ticketmaster.com/blues/"
        >
          Account Manager
        </Link>{" "}
        using our secure Ticketmaster login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for the games.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your St. Louis Blues{" "}
        <Link
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
          href="https://am.ticketmaster.com/blues/"
        >
          Account Manager
        </Link>{" "}
        within 24 hours of purchase. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How do the St. Louis Blues Flex Plan work?",
    description:
      "The St. Louis Blues Flex Plan lets you fully customize your experience. You choose any home games that best fit your schedule and select any available seats for each game—giving you flexibility and control over your season.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Event tickets are delivered directly within your St. Louis Blues{" "}
        <Link
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
          href="https://am.ticketmaster.com/blues/"
        >
          Account Manager
        </Link>
        .
      </>
    ),
  },
];

export const StLouisBluesFlexCheckoutTerms = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      href="https://www.attend.tech/privacy-policy"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </Link>
    .
  </>
);

export const StLouisBluesFlexRegistrationTerms = () => (
  <>
    By creating an account you agree to receive email notifications regarding
    your purchase and to the{" "}
    <Link
      href="https://www.attend.tech/terms-of-use"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link
      href="https://www.attend.tech/privacy-policy"
      target={"_blank"}
      sx={{
        color: "primary.main",
        textDecoration: "none",
        fontWeight: 500,
      }}
    >
      Privacy Policy
    </Link>
    .
  </>
);
